import path from '@/api/index'
import { axios } from '@/utils/request'
import parsePageParams from "../../utils/page";
// 分页
export function getOrganizeList(data) {
    return axios({
        url: path.client + '/courseSelection/getOrganizeList',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}


export function getInstitutionById(data){
    return axios({
        url: path.client + '/courseSelection/getInstitutionById',
        method: 'GET',
        params: data
    })
}


export function getTeacherList(data){
    return axios({
        url: path.client + '/courseSelection/getTeacherList',
        method: 'GET',
        params: data
    })
}
